module.exports = __webpack_public_path__ + "static/media/gif_SE_step_2.bead409b.gif";